<div class="assign_modal_overlay" *ngIf="show">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ sliderConfig().title }}</h3>
      <button class="close-button" (click)="closeSlider()">
       <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="modal-content">
      <div class="assign_modal_section">
        <ng-select
         #assigneeSelect
         [items]="ngSelectItems()"
          bindLabel="name"
          bindValue="_id"
          [ngModel]="selectedUserIds()"
          (ngModelChange)="selectedUserIds.set($event); onUserSelectionChange($event)"
          (add)="onAssigneeAdd()"
          (remove)="onAssigneeRemove()"
          (selectionChanges)="onAssigneeSelectionChanges()"
          (select)="onAssigneeSelect()"
          (change)="onAssigneeChange()"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          [closeOnSelect]="false"
          [virtualScroll]="true"
          [loading]="isLoadingData"
          [placeholder]="isLoadingData ? sliderConfig().loadingText : sliderConfig().placeholder"
          (search)="onAssigneeSearch($event)"
          (blur)="onAssigneeBlur()"
          (open)="onAssigneeOpen()"
          
          [ngClass]="{'has-tooltip': selectedUsers().length > 2}"
          [title]="selectedUsers().length > 2 ? selectedUsers().map(getDisplayName).join(', ') : ''"
          [isOpen]="showDropdown()"
          class="assign_modal_select modal-ng-select">
          <ng-template ng-multi-label-tmp let-items="items">
            <div class="ng-select-selected-items">
              <ng-container *ngFor="let item of items; let i = index">
                <ng-container *ngIf="i < 1">
                  <div class="ng-select-item">
                    <div class="ng-select-item-content">
                      <span class="ng-select-item-name">{{ getDisplayName(item) }}</span>
                      <span [ngClass]="getTypeBadgeClass(item)" class="type-badge-small">{{ getTypeLabel(item) }}</span>
                    </div>
                    <button 
                      class="ng-select-item-remove" 
                      (click)="removeSelectedUserFromNgSelect(item, $event)" 
                      title="Remove user"
                      type="button">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.938477 1.02026L7.16113 7.24292" stroke="currentColor" stroke-width="0.541101"/>
                        <path d="M7.16113 1.02026L0.938476 7.24292" stroke="currentColor" stroke-width="0.541101"/>
                      </svg>
                    </button>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="items.length > 1">
                <div class="ng-select-item ng-select-item-more more_assignees">
                  +{{ items.length - 1 }} more
                </div>
              </ng-container>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="template-option">
              <div class="user-avatar" [class.has-image]="hasValidImage(item)">
                <img 
                  *ngIf="hasValidImage(item)"
                  [src]="item.image || item.avatar" 
                  [alt]="getDisplayName(item)"
                  (error)="onImageError(item._id)"
                  class="avatar-image" />
                <div 
                  *ngIf="!hasValidImage(item)"
                  class="avatar-placeholder"
                  [style.background-color]="getAvatarColor(item._id)">
                  {{ getInitials(getDisplayName(item)) }}
                </div>
              </div>
              <span class="user-name">{{ getDisplayName(item) }}</span>
              <span [ngClass]="getTypeBadgeClass(item)" class="type-badge">{{ getTypeLabel(item) }}</span>
            </div>
          </ng-template>
          <ng-template ng-notfound-tmp>
            <div class="no-results">
              <mat-icon>search_off</mat-icon>
              <p>{{ sliderConfig().noResultsText }}</p>
            </div>
          </ng-template>
        </ng-select>
      </div>
      
      <div class="assign_modal_selected" *ngIf="selectedUsers().length > 0">
        <label class="assign_modal_label">Selected Assignees ({{ selectedUsers().length }})</label>
        <div class="assign_modal_selected_list">
          <div class="assign_modal_selected_item" *ngFor="let user of selectedUsers(); let i = index">
            <div class="assign_modal_avatar" [class.has-image]="hasValidImage(user)">
              <img 
                *ngIf="hasValidImage(user)"
                [src]="user.image || user.avatar" 
                [alt]="getDisplayName(user)"
                (error)="onImageError(user._id)"
                class="avatar-image" />
              <div 
                *ngIf="!hasValidImage(user)"
                class="avatar-placeholder"
                [style.background-color]="getAvatarColor(user._id)">
                {{ getInitials(getDisplayName(user)) }}
              </div>
            </div>
            <div class="assignee-info">
              <span class="assignee-name">{{ getDisplayName(user) }}</span>
              <span [ngClass]="getTypeBadgeClass(user)" class="type-badge">{{ getTypeLabel(user) }}</span>
            </div>
            <button class="assign_modal_remove_btn" (click)="removeSelectedUser(i)" title="Remove user">
             <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
      
      <!-- No Changes Message -->
      <div class="no-changes-message" *ngIf="showNoChangesMessage()">
        <div class="message-content">
          <mat-icon class="message-icon">info</mat-icon>
          <span class="message-text">{{ sliderConfig().noChangesMessage }}</span>
        </div>
      </div>
    </div>
    
    <div class="modal-actions">
      <button class="btn-save" (click)="onAssignUsersClick()" [disabled]="selectedUsers().length === 0">
        {{ sliderConfig().confirmText }}
      </button>
      <button class="btn-cancel" (click)="closeSlider()">{{ sliderConfig().cancelText }}</button>
    </div>
  </div>
</div>

<app-confirm-popup
  [show]="showAssignConfirmPopup()"
  [config]="{
    title: 'Assign Users',
    message: 'Are you sure you want to assign the selected users?',
    type: 'info',
    showCancel: true,
    cancelText: 'Cancel',
    confirmText: 'Assign Users'
  }"
  (confirm)="confirmAssignUsers()"
  (cancel)="cancelAssignUsers()"
></app-confirm-popup> 